import { useMemo } from 'react'
import { z } from 'zod'

import * as api from '../api'
import { useApiQuery } from '../useApiQuery'

const dataParser = z.object({
  total: z.number(),
  histogram: z.array(
    z.object({
      when: z.string(),
      total: z.number(),
      entries: z.array(
        z.object({
          seconds: z.number(),
          uuid: z.string(),
        })
      ),
    })
  ),
})

export default function useTimeInvested({ fromDate, toDate }: { fromDate: string; toDate: string }) {
  const defaultData = useMemo(() => ({ fromDate, toDate, days: [] }), [fromDate, toDate])

  const result = useApiQuery({
    queryKey: ['useTimeInvested', fromDate, toDate],
    placeholderData: (previousData) => previousData || defaultData,
    queryFn: async () => {
      const res = await api.get(
        `personal-insights/time-invested?from=${encodeURIComponent(fromDate)}&to=${encodeURIComponent(toDate)}`
      )
      return {
        fromDate,
        toDate,
        days: dataParser.parse(res).histogram,
      }
    },
  })

  return { ...result, data: result.data || defaultData }
}
